export enum Month {
   January = 0,
   February = 1,
   March = 2,
   April = 3,
   May = 4,
   June = 5,
   July = 6,
   August = 7,
   September = 8,
   October = 9,
   November = 10,
   Dezember = 11
}

export let AllMonths = [Month.January, Month.February, Month.March, Month.April, Month.May, Month.June, Month.July, Month.August, Month.September, Month.October, Month.November, Month.Dezember];

export const MonthNames = [
   "Januar",
   "Februar",
   "März",
   "April",
   "Mai",
   "Juni",
   "Juli",
   "August",
   "September",
   "Oktober",
   "November",
   "Dezember"
];